import { render, staticRenderFns } from "./DashboardCampaigns.vue?vue&type=template&id=750a1586&scoped=true&"
import script from "./DashboardCampaigns.vue?vue&type=script&lang=js&"
export * from "./DashboardCampaigns.vue?vue&type=script&lang=js&"
import style0 from "./DashboardCampaigns.vue?vue&type=style&index=0&id=750a1586&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "750a1586",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/buddy/kontalk/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
installComponents(component, {VBtn,VDivider,VIcon})
